export default __webpack_public_path__ + "static/media/621.cc76e1c1.png";